<section class="favie__main-layout h-100">
  <favie-header *ngIf="isHeaderVisible">
    <ng-content select="[header]"></ng-content>
  </favie-header>

  <div class="layout-page h-100"
        [class.page-with-contextual-sidebar]="showSidebar"
        [class.page-with-contextual-expanded-sidebar]="showSidebar && isExpandSidebar && currentLayout !== layouts.MOBILE"
        [class.page-full-width]="currentLayout === layouts.MOBILE">
    <favie-sidebar [logo]="sidebarLogo" [items]="sidebarItems" (mouseover)="onMouseHoverSidebar(true)"
      (mouseleave)="onMouseHoverSidebar(false)" [class.d__none]="currentLayout === layouts.MOBILE">
      <ng-content header select="[sidebar-header]"></ng-content>
      <ng-content footer select="[sidebar-footer]"></ng-content>
    </favie-sidebar>
    <div class="content__wrapper h-100" [class.content__wrapper--with-contextual-header]="isHeaderVisible">
      <div class="alert__wrapper"></div>
      <div class="container-fluid container-limited limit-container-width h-100">
        <ng-content select="[content]"></ng-content>
      </div>
    </div>
  </div>
</section>